import { render, staticRenderFns } from "./WaiterProgressHistoriesTab.vue?vue&type=template&id=967e5b70&scoped=true&lang=pug"
import script from "./WaiterProgressHistoriesTab.vue?vue&type=script&lang=ts"
export * from "./WaiterProgressHistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterProgressHistoriesTab.vue?vue&type=style&index=0&id=967e5b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967e5b70",
  null
  
)

export default component.exports